const resolveString = ({ rawVal }: StringProps) => {
  return rawVal?.trim().replace(/"/g, '');
};

export default resolveString;
